<template>
  <span>test</span>
</template>

<script>
export default {
  name: "RegisterProject"
}
</script>

<style scoped>

</style>